import axios from "axios";
import Cookies from "js-cookie";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import ContainedWithIconButton from "components/buttons/ContainedWithIconButton";
import GetAppIcon from "@material-ui/icons/GetApp";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  StyledTableCell,
  StyledTableRow,
  useStyles,
} from "components/profiles/ProfileStyles";
import { screenStyles } from "../../Styles";
import {
  translateLSBDTransactionsTypes,
  TransactionsTypes,
} from "../../ScreenUtils";
import Actions from "./ExpensesTableActions";
import { FormatDateToFront } from "utils/dates/FormatDateToFront";
import { valueToMoneyFloat } from "utils/general/valueToMoneyFloat";
import { moneyMask } from "utils/masks/moneyMask";
import { Box } from "@material-ui/core";
import { dateToBR } from "utils/dates/DateToBRr";
import { compareStrings } from "utils/sort/strings";
import { createContent } from "utils/tables/createContent";

function desc(a, b, orderBy) {
  if (a[orderBy] === null || a[orderBy] === undefined) {
    a[orderBy] = "";
  }
  if (b[orderBy] === null || b[orderBy] === undefined) {
    b[orderBy] = "";
  }

  if (orderBy === "date" || orderBy === "value") {
    if (
      b[orderBy] < a[orderBy] ||
      b["date"] < a["date"] ||
      b["createdAt"] < a["createdAt"]
    )
      return -1;
    if (
      b[orderBy] > a[orderBy] ||
      b["date"] > a["date"] ||
      b["createdAt"] > a["createdAt"]
    )
      return 1;

    return 0;
  }

  if (orderBy === "type") {
    var translate = translateLSBDTransactionsTypes;
    if (translate(b[orderBy]) < translate(a[orderBy])) return -1;
    if (translate(b[orderBy]) > translate(a[orderBy])) return 1;

    if (b["date"] > a["date"] || b["createdAt"] > a["createdAt"]) return 1;
    if (b["date"] < a["date"] || b["createdAt"] < a["createdAt"]) return -1;

    return 0;
  }

  if (orderBy === "user") {
    let attributeA = a["operator"] ? "operator" : "user";
    let attributeB = b["operator"] ? "operator" : "user";

    return compareStrings(
      a[attributeB].name.toString(),
      b[attributeB].name.toString()
    );
  }
  if (b["date"] > a["date"] || b["createdAt"] > a["createdAt"]) {
    return 1;
  }
  if (b["date"] < a["date"] || b["createdAt"] < a["createdAt"]) {
    return -1;
  }
  return 0;
}

const ExpensesTable = props => {
  const fileDownload = require("js-file-download");
  const styles = screenStyles();
  const classes = useStyles();
  const [t] = useTranslation();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState({});
  const [rowsLength, setRowsLength] = useState(0);
  const [headers, setHeaders] = useState([]);
  const [mainField, setMainField] = useState("");
  const [visibleHeaders, setVisibleHeaders] = useState([]);
  const [sortedFields, setSortedFields] = useState([]);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("name");

  React.useEffect(() => {
    setHeaders(props.headers);
    setRows(props.rows);
    setRowsLength(props.rows.length);
    setMainField(props.mainField);
    setVisibleHeaders(props.visibleHeaders);
    setSortedFields(props.sortedFields);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.headers, props.mainField, props.rows, props.visibleHeaders]);

  function handlePageChange(event, newPage) {
    setPage(newPage);
  }
  const handleRowsPerPageChange = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === sortedFields[property] && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(sortedFields[property]);
  };

  const UsersTableHead = props => {
    const { order, orderBy, onRequestSort } = props;
    const [t] = useTranslation();
    const paginationTop = action => e => {
      var selector = "[aria-label^='" + action + "']";
      document.querySelector(selector).click();
      e.preventDefault();
    };
    const createSortHandler = property => event => {
      onRequestSort(event, property);
    };

    let actionIndex = 5;

    return (
      <TableHead>
        <TableRow>
          {visibleHeaders.map((header, index) => (
            <StyledTableCell
              key={index}
              size="small"
              align="left"
              sortDirection={orderBy === sortedFields[index] ? order : false}
            >
              {index !== 4 && index !== 5 ? (
                <TableSortLabel
                  active={orderBy === sortedFields[index]}
                  direction={order}
                  onClick={createSortHandler(index)}
                >
                  {header.toUpperCase()}
                  {orderBy === sortedFields[index] ? (
                    <span className={classes.visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              ) : (
                <>{header.toUpperCase()}</>
              )}
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  UsersTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
  };

  React.useEffect(() => {
    if (props.toFirstPage) {
      document.getElementById("toFirstPage").click();
    }
  }, [props.rows, props.toFirstPage]);

  const toFirstPage = () => {
    setPage(0);
  };

  const onClickDownload = async slashPath => {
    if (slashPath) {
      const noSlashPath = slashPath.replace(/\//g, ";");
      const url = process.env.REACT_APP_FILE + noSlashPath;
      axios
        .get(url, {
          headers: {
            "Content-type": "application/json",
            Authorization:
              "bearer " +
              (Cookies.get("auth-token") ? Cookies.get("auth-token") : ""),
          },
          responseType: "blob",
        })
        .then(function (res) {
          const blob = new Blob([res.data], {});
          const name = slashPath.split("/").pop();
          fileDownload(blob, name);
        });
    }
  };

  return (
    <Paper className={classes.root}>
      <div className={classes.tableWrapper}>
        <Table className={classes.table} size="small">
          {rows.length > 0 && (
            <UsersTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
          )}
          <TableBody>
            {createContent(rows, headers, order, orderBy, desc)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(row => (
                <StyledTableRow key={row.id}>
                  <TableCell size="small" width={"15%"}>
                    {row["date"]
                      ? dateToBR(FormatDateToFront(row["date"]))
                      : "-"}
                  </TableCell>

                  <TableCell size="small">
                    {row["operator"].collaboratorName ??
                      row["user"].collaboratorName ??
                      "-"}
                  </TableCell>

                  <TableCell size="small" width={"30%"}>
                    {row["type"]
                      ? translateLSBDTransactionsTypes(
                          row["type"],
                          row["source"]
                        )
                      : "-"}
                  </TableCell>

                  <TableCell size="small">
                    {row["value"] ? (
                      <Box
                        color={
                          row["type"] === TransactionsTypes.CREDIT
                            ? "#27AE60"
                            : row["type"] === TransactionsTypes.DEBIT
                            ? "#F3222F"
                            : null
                        }
                        fontWeight="700"
                      >
                        {`${
                          row["type"] === TransactionsTypes.CREDIT ? "+" : "-"
                        } R$
                                                ${moneyMask(
                                                  valueToMoneyFloat(
                                                    Math.abs(row["value"])
                                                  )
                                                )}
                                                `}
                      </Box>
                    ) : (
                      "-"
                    )}
                  </TableCell>
                  <TableCell size="small" align="left">
                    <ContainedWithIconButton
                      disabled={!(row["receiptPath"] && row["receiptFilename"])}
                      text={t("GENERAL.download")}
                      Icon={GetAppIcon}
                      style={{
                        height: "40px",
                        opacity: "1",
                        color: "white",
                      }}
                      onClick={() =>
                        onClickDownload(
                          row["receiptPath"] + "/" + row["receiptFilename"]
                        )
                      }
                    />
                  </TableCell>

                  <TableCell size="small" align="right">
                    <div
                      style={{
                        marginTop: "auto",
                        marginBottom: "auto",
                        display: "flex",
                        flexWrap: "nowrap ",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Actions
                        item={row}
                        name={row.shortname}
                        permission={props.permission}
                      />
                    </div>
                  </TableCell>
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
        <button hidden id="toFirstPage" onClick={toFirstPage}></button>
        {rows.length > 0 && (
          <TableFooter style={{ float: "right" }}>
            <TablePagination
              labelRowsPerPage={"Resultados por página"}
              count={rowsLength}
              rowsPerPage={rowsPerPage}
              page={page}
              component="div"
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleRowsPerPageChange}
            />
          </TableFooter>
        )}
      </div>
    </Paper>
  );
};

ExpensesTable.propTypes = {
  rows: PropTypes.array.isRequired,
  headers: PropTypes.array.isRequired,
  visibleHeaders: PropTypes.array.isRequired,
  mainField: PropTypes.string.isRequired,
};

export default ExpensesTable;
